export default "__VITE_ASSET__B4CDFg$S__"